import {Block, GameObject, Constant, Variable} from "./index";

export class FunctionBlock extends Block {
  get type() {
    return "FunctionBlock";
  }

  get category() {
    return "FunctionBlock";
  }

  getAvailableChildTypesAt() {
    return [GameObject, Constant, Variable];
  }
}
